import { useFormContext, Controller } from "@/shared/libs/react-hook-form";
import { FieldWrapper, FieldWrapperPassThroughProps } from "../../index";
import SelectComponent, {
  SelectProps as SelectComponentProps,
} from "@/shared/components/Select";

export type SelectProps = FieldWrapperPassThroughProps &
  SelectComponentProps & {
    field: string;
    required?: boolean;
    defaultValue?: string | number;
    selectClassName?: string
  };

export const Select = ({
  className,
  field,
  required,
  defaultValue,
  label,
  error,
  inline,
  labelNum,
  selectClassName,
  ...iconSelectProps
}: SelectProps) => {
  const methods = useFormContext();

  return (
    <Controller
      control={methods?.control}
      defaultValue={defaultValue ?? ""}
      name={field}
      render={(props) => {
        return (
          <FieldWrapper
            className={className}
            label={label}
            inline={inline}
            labelNum={labelNum}
            error={error ?? methods?.formState.errors[field]}
            required={required}
          >
            <SelectComponent
              {...iconSelectProps}
              className={selectClassName}
              value={props.field.value}
              onChange={props.field.onChange}
              // inputProps={props.field}
            />
          </FieldWrapper>
        );
      }}
    />
  );
};
